import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { environment } from 'src/environemnts/environment';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClassesService {

  //Observables
  private newClass = new Subject<any>();
  newClass$ = this.newClass.asObservable();
  private userToClass = new Subject<any>();
  userToClass$ = this.userToClass.asObservable();
  private removeUserToClass = new Subject<any>();
  removeUserToClass$ = this.removeUserToClass.asObservable();
  private classUpdated = new Subject<any>();
  classUpdated$ = this.classUpdated.asObservable();
  private classRemoved = new Subject<any>();
  classRemoved$ = this.classRemoved.asObservable();
  private classUpdatedAll = new Subject<any>();
  classUpdatedAll$ = this.classUpdatedAll.asObservable();
  private educatorClasses = new Subject<any>();
  educatorClasses$ = this.educatorClasses.asObservable();

  constructor(private httpClient: HttpClient, private authService: AuthService) { }

  /**
  * Create a new class
  */
  createClass(classData: Object) {

    let headers = {
      headers: new HttpHeaders()
        .set('X-Pasiphae-Auth', this.authService.sessionToken)
        .set('X-Pilot-Code', this.authService.pilot)
        .set('X-User-Role', this.authService.role)
        .set('X-User-Id', String(this.authService.uuid))
    }

    let body = classData;

    this.httpClient.post(environment.baseUrl + '/ClassProfiles', body, headers).subscribe((data: any) => {

      let datos = JSON.parse(JSON.stringify(data));

      this.newClass.next(datos);

    }, error => {
      console.log("Error :", JSON.parse(JSON.stringify(error)));
      this.newClass.next(`error${error.status},${error.message}`);
      throw new Error(`Error in createClass() method with user id: ${this.authService.uuid} + ${this.authService.pilot}, error ${(error.status ?? 'error status not available')}, description ${(JSON.stringify(error.message) ?? 'error message not available')}, error  ${(JSON.stringify(error.error) ?? 'error.error not available')}`);
    })

  }

    /**
   * Method to obtain all classes
   * @param classId 
   * @returns 
   */
  getAllClasses() {

    let headers = {
      headers: new HttpHeaders()
        .set('X-Pasiphae-Auth', this.authService.sessionToken)
        .set('X-Pilot-Code', this.authService.pilot)
        .set('X-User-Role', this.authService.role)
        .set('X-User-Id', String(this.authService.uuid))
    }

    return this.httpClient.get(environment.baseUrl + '/ClassProfiles/', headers);

  }


  /**
   * Method to obtain class by id
   * @param classId 
   * @returns 
   */
  getClassById(classId: number) {

    let headers = {
      headers: new HttpHeaders()
        .set('X-Pasiphae-Auth', this.authService.sessionToken)
        .set('X-Pilot-Code', this.authService.pilot)
        .set('X-User-Role', this.authService.role)
        .set('X-User-Id', String(this.authService.uuid))
    }

    return this.httpClient.get(environment.baseUrl + '/ClassProfiles/' + classId, headers);

  }


  /**
   * Method to associate class to a educator
   * @param userId
   * @param classId 
   */
  associateClassToUser(userId: Number, classId: Number) {

    let headers = {
      headers: new HttpHeaders()
        .set('X-Pasiphae-Auth', this.authService.sessionToken)
        .set('X-Pilot-Code', this.authService.pilot)
        .set('X-User-Role', this.authService.role)
        .set('X-User-Id', String(this.authService.uuid))
    }

    let body = [classId];

    this.httpClient.post(environment.baseUrl + '/Profiles/' + userId + '/setClassToProfile', body, headers).subscribe((data: any) => {

      this.userToClass.next("correct");

    }, error => {
      console.log("Error :", JSON.parse(JSON.stringify(error)));
      this.userToClass.next(`error${error.status},${error.message}`);
      throw new Error(`Error in associateClassToUser() method with user id: ${this.authService.uuid} + ${this.authService.pilot}, error ${(error.status ?? 'error status not available')}, description ${(JSON.stringify(error.message) ?? 'error message not available')}, error  ${(JSON.stringify(error.error) ?? 'error.error not available')}`);
    })
  }


  /**
 * Method to remove association class-educator
 * @param userId
 * @param classId 
 */
  removeClassFromUser(userId: Number, classId: Number) {

    let headers = new HttpHeaders()
      .set('X-Pasiphae-Auth', this.authService.sessionToken)
      .set('X-Pilot-Code', this.authService.pilot)
      .set('X-User-Role', this.authService.role)
      .set('X-User-Id', String(this.authService.uuid))

    const options = {
      headers: headers
    };

    this.httpClient.delete(environment.baseUrl + '/Profiles/' + userId + '/removeClassFromProfile/' + classId, options).subscribe((data: any) => {

      let datos = JSON.parse(JSON.stringify(data));
      this.removeUserToClass.next("correct");

    }, error => {
      console.log("Error :", JSON.parse(JSON.stringify(error)));
      this.removeUserToClass.next(`error${error.status},${error.message}`);
      throw new Error(`Error in removeClassFromUser() method with user id: ${this.authService.uuid} + ${this.authService.pilot}, error ${(error.status ?? 'error status not available')}, description ${(JSON.stringify(error.message) ?? 'error message not available')}, error  ${(JSON.stringify(error.error) ?? 'error.error not available')}`);
    })
  }

  /**
   * Method to remove association class-educator after creating a profile
   * @param userId 
   * @param classId 
   * @returns 
   */
  removeClassFromCreatedUser(userId: Number, classId: Number) {

    let headers = new HttpHeaders()
      .set('X-Pasiphae-Auth', this.authService.sessionToken)
      .set('X-Pilot-Code', this.authService.pilot)
      .set('X-User-Role', this.authService.role)
      .set('X-User-Id', String(this.authService.uuid))

    const options = {
      headers: headers
    };

    return this.httpClient.delete(environment.baseUrl + '/Profiles/' + userId + '/removeClassFromProfile/' + classId, options);


  }


  /**
   * Method to edit class data
   * @param classData 
   */
  editClassData(id: number, classData: any) {

    let headers = {
      headers: new HttpHeaders()
        .set('X-Pasiphae-Auth', this.authService.sessionToken)
        .set('X-Pilot-Code', this.authService.pilot)
        .set('X-User-Role', this.authService.role)
        .set('X-User-Id', String(this.authService.uuid))
    }

    let body = classData;

    this.httpClient.patch(environment.baseUrl + '/ClassProfiles/' + id, body, headers).subscribe((data: any) => {

      let datos = JSON.parse(JSON.stringify(data));

      this.classUpdated.next([{ id: id }]);

    }, error => {
      console.log("Error :", JSON.parse(JSON.stringify(error)));
      this.classUpdated.next(`error${error.status},${error.message}`);
      throw new Error(`Error in editClassData() method with user id: ${this.authService.uuid} + ${this.authService.pilot}, error ${(error.status ?? 'error status not available')}, description ${(JSON.stringify(error.message) ?? 'error message not available')}, error  ${(JSON.stringify(error.error) ?? 'error.error not available')}`);
    })

  }


  /**
   * Method to edit all class data
   * @param classData 
   */
  editAllClassData(id: number, classData: any) {

    let headers = {
      headers: new HttpHeaders()
        .set('X-Pasiphae-Auth', this.authService.sessionToken)
        .set('X-Pilot-Code', this.authService.pilot)
        .set('X-User-Role', this.authService.role)
        .set('X-User-Id', String(this.authService.uuid))
    }

    let body = classData;

    this.httpClient.patch(environment.baseUrl + '/ClassProfiles/' + id, body, headers).subscribe((data: any) => {

      let datos = JSON.parse(JSON.stringify(data));

      this.classUpdatedAll.next([{ id: id }]);

    }, error => {
      console.log("Error :", JSON.parse(JSON.stringify(error)));
      this.classUpdatedAll.next(`error${error.status},${error.message}`);
      throw new Error(`Error in editAllClassData() method with user id: ${this.authService.uuid} + ${this.authService.pilot}, error ${(error.status ?? 'error status not available')}, description ${(JSON.stringify(error.message) ?? 'error message not available')}, error  ${(JSON.stringify(error.error) ?? 'error.error not available')}`);
    })

  }

    /**
   * Method to edit class data
   * @param classData 
   */
  editClassDataObservable(id: number, classData: any) {

    let headers = {
      headers: new HttpHeaders()
        .set('X-Pasiphae-Auth', this.authService.sessionToken)
        .set('X-Pilot-Code', this.authService.pilot)
        .set('X-User-Role', this.authService.role)
        .set('X-User-Id', String(this.authService.uuid))
    }

    let body = classData;

    return this.httpClient.patch(environment.baseUrl + '/ClassProfiles/' + id, body, headers);

  }

  /**
   * Method to remove class
   * @param classData 
   */
  removeClass(id: number) {

    let headers = {
      headers: new HttpHeaders()
        .set('X-Pasiphae-Auth', this.authService.sessionToken)
        .set('X-Pilot-Code', this.authService.pilot)
        .set('X-User-Role', this.authService.role)
        .set('X-User-Id', String(this.authService.uuid))
    }

    this.httpClient.delete(environment.baseUrl + '/ClassProfiles/' + id, headers).subscribe((data: any) => {

      let datos = JSON.parse(JSON.stringify(data));

      this.classRemoved.next([{ id: id }]);

    }, error => {
      console.log("Error :", JSON.parse(JSON.stringify(error)));
      this.classRemoved.next(`error${error.status},${error.message}`);
      throw new Error(`Error in removeClass() method with user id: ${this.authService.uuid} + ${this.authService.pilot}, error ${(error.status ?? 'error status not available')}, description ${(JSON.stringify(error.message) ?? 'error message not available')}, error  ${(JSON.stringify(error.error) ?? 'error.error not available')}`);
    })

  }


  /**
   * Method to reveal class study and group
   */
  revealClassAssignment(classId: number) {

    let headers = {
      headers: new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this.authService.sessionToken)
    }

    let body = { "interventionBlind": 0 };

    this.httpClient.put(environment.baseUrl + '/ClassProfiles/' + classId, body, headers).subscribe((data: any) => {

      let datos = JSON.parse(JSON.stringify(data));

      this.newClass.next(datos);

    }, error => {
      console.log("Error :", JSON.parse(JSON.stringify(error)));
      this.newClass.next('error' + error.status + error.error.error_description);
    })

  }

    /**
   * Method to obtain associated classes and children from an educator
   * @param educatorId 
   * @returns 
   */
    getClassesByEducator(educatorId: number) {

      let headers = {
        headers: new HttpHeaders()
          .set('X-Pasiphae-Auth', this.authService.sessionToken)
          .set('X-Pilot-Code', this.authService.pilot)
          .set('X-User-Role', this.authService.role)
          .set('X-User-Id', String(this.authService.uuid))
      }
  
      return this.httpClient.get(environment.baseUrl + '/Educators/' + educatorId + '/classInfo', headers);
  
    }

  /**
   * Method to obtain associated classes and children from an educator
   * @param educatorId 
   * @returns 
   */
    getClassesByEducatorTotal(educatorId: number) {

    let headers = {
      headers: new HttpHeaders()
        .set('X-Pasiphae-Auth', this.authService.sessionToken)
        .set('X-Pilot-Code', this.authService.pilot)
        .set('X-User-Role', this.authService.role)
        .set('X-User-Id', String(this.authService.uuid))
    }

    this.httpClient.get(environment.baseUrl + '/Educators/' + educatorId + '/classInfo', headers).subscribe((data: any) => {

      let datos = JSON.parse(JSON.stringify(data));

      //Order children from recent to old
      datos.forEach((item:any) => {

        item.children = item.children.sort((a: any, b: any) => 
          new Date(b.registrationDate).getTime() - new Date(a.registrationDate).getTime());
      })

      this.educatorClasses.next(datos);

    }, error => {
      console.log("Error :", JSON.parse(JSON.stringify(error)));
      this.educatorClasses.next(`error${error.status},${error.message}`);
      throw new Error(`Error in getClassesByEducatorTotal() method with user id: ${this.authService.uuid} + ${this.authService.pilot}, error ${(error.status ?? 'error status not available')}, description ${(JSON.stringify(error.message) ?? 'error message not available')}, error  ${(JSON.stringify(error.error) ?? 'error.error not available')}`);
    })

  }





  /**
  * Method to read JSON file
  * @param location 
  * @returns 
  */
  getJSON(location: string): Observable<any> {
    return this.httpClient.get(location);
  }




}
